import { Component } from '@angular/core';
import { OperationsService } from '../../../../core/services/operations.service';

import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { IntestazioneFascicoloService } from '../../../services/intestazione-fascicolo-service';

declare var openModal: any;
declare var getFascicoloMapSync;

@Component({
    selector: '[define-fascicolo]',
  template: 'Definisci fascicolo'
})


export class DefineFascicoloComponent {

  constructor(protected operationService: OperationsService, private intestazioneFascicoloService: IntestazioneFascicoloService) {}

  defineFascicolo(fascicolo: FascicoloFull) {
    let fascicoloMap = this.getFascicoloFromMap(fascicolo.tipoFascicolo.id, fascicolo.praticaBase.tipoPratica.id);
    this.operationService.defineFascicolo(fascicoloMap.pathDefine, fascicolo.id).subscribe(response => this.fascicoloDefined(response, fascicolo));
  }

  fascicoloDefined(response, fascicolo: FascicoloFull) {
    if (response.returnCode === 'OK') {
    }
  }

  private getFascicoloFromMap(idTipoFascicoloMap: any, idTipoPraticaMap: any) {
    // let nomeFascicoloFE = FrontEndMapping.tipiFascicolo[idTipoFascicoloMap];
    // let nomePraticaFE = FrontEndMapping.tipiPratica[idTipoPraticaMap];
    let fascicolo = getFascicoloMapSync(idTipoPraticaMap, idTipoFascicoloMap);
    return fascicolo;
  }
}
